type Props = {
  width: string;
  height: string;
  fill?: string;
};

const bigFBLogo =
  import.meta.env.VITE_PUBLICATION === "hbs" ||
  import.meta.env.VITE_PUBLICATION === "hw";

export const Facebook = ({ width, height, fill = "black" }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 44 44"
    fill="none"
  >
    {bigFBLogo ? (
      <>
        <circle cx="21.5" cy="21.5" r="21" fill="#fff" />
        <path
          d="M43 21.69C43 9.74329 33.3741 0.0585938 21.5 0.0585938C9.62587 0.0585938 0 9.74329 0 21.69C0 32.4867 7.8622 41.4358 18.1406 43.0586V27.9428H12.6816V21.69H18.1406V16.9243C18.1406 11.503 21.3505 8.50836 26.2615 8.50836C28.6139 8.50836 31.0742 8.93085 31.0742 8.93085V14.2542H28.3632C25.6925 14.2542 24.8594 15.9218 24.8594 17.6324V21.69H30.8223L29.869 27.9428H24.8594V43.0586C35.1378 41.4358 43 32.4871 43 21.69Z"
          fill={fill}
        />
      </>
    ) : (
      <>
        <circle cx="22" cy="22" r="22" fill={fill} />
        <path
          d="M25.8465 23.6845L26.3651 20.2497H23.1234V18.0178C23.1234 17.0786 23.5747 16.1605 25.027 16.1605H26.5V13.2322C25.6338 13.0897 24.7624 13.0106 23.8859 13C21.2147 13 19.4668 14.6462 19.4668 17.6273V20.2497H16.5V23.6898H19.4668V32H23.1183V23.6898H25.8413L25.8465 23.6845Z"
          fill="white"
        />
      </>
    )}
  </svg>
);

export const Whatsapp = ({ width, height, fill = "black" }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 44 43"
    fill="none"
  >
    <circle cx="21.6172" cy="21.5" r="21.5" fill={fill} />
    <path
      d="M30.5225 12.4875C28.2779 10.2375 25.2886 9 22.1118 9C15.5547 9 10.219 14.3357 10.219 20.8929C10.219 22.9875 10.7654 25.0339 11.8047 26.8393L10.1172 33L16.4225 31.3446C18.1583 32.2929 20.1136 32.7911 22.1065 32.7911H22.1118C28.6636 32.7911 34.1172 27.4554 34.1172 20.8982C34.1172 17.7214 32.7672 14.7375 30.5225 12.4875ZM22.1118 30.7875C20.3333 30.7875 18.5922 30.3107 17.0761 29.4107L16.7172 29.1964L12.9779 30.1768L13.9743 26.5286L13.7386 26.1536C12.7475 24.5786 12.2279 22.7625 12.2279 20.8929C12.2279 15.4446 16.6636 11.0089 22.1172 11.0089C24.7583 11.0089 27.2386 12.0375 29.1029 13.9071C30.9672 15.7768 32.1136 18.2571 32.1083 20.8982C32.1083 26.3518 27.56 30.7875 22.1118 30.7875ZM27.5333 23.3839C27.2386 23.2339 25.7761 22.5161 25.5029 22.4196C25.2297 22.3179 25.0315 22.2696 24.8333 22.5696C24.635 22.8696 24.0672 23.5339 23.8904 23.7375C23.719 23.9357 23.5422 23.9625 23.2475 23.8125C21.5011 22.9393 20.3547 22.2536 19.2029 20.2768C18.8975 19.7518 19.5083 19.7893 20.0761 18.6536C20.1725 18.4554 20.1243 18.2839 20.0493 18.1339C19.9743 17.9839 19.3797 16.5214 19.1333 15.9268C18.8922 15.3482 18.6458 15.4286 18.4636 15.4179C18.2922 15.4071 18.094 15.4071 17.8958 15.4071C17.6975 15.4071 17.3761 15.4821 17.1029 15.7768C16.8297 16.0768 16.0636 16.7946 16.0636 18.2571C16.0636 19.7196 17.1297 21.1339 17.2743 21.3321C17.4243 21.5304 19.369 24.5304 22.3529 25.8214C24.2386 26.6357 24.9779 26.7054 25.9208 26.5661C26.494 26.4804 27.6779 25.8482 27.9243 25.1518C28.1708 24.4554 28.1708 23.8607 28.0958 23.7375C28.0261 23.6036 27.8279 23.5286 27.5333 23.3839Z"
      fill="white"
    />
  </svg>
);

export const Tiktok = ({ width, height, fill = "black" }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 44 44"
  >
    <circle cx="21.5" cy="21.5" r="21.5" fill={fill} />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M23.8784 27.3211c-.0693 1.9264-1.6774 3.473-3.632 3.473-.4436 0-.8734-.0843-1.2754-.2249.402.1546.8318.2249 1.2754.2249 1.9685 0 3.5627-1.5466 3.632-3.473V10.0967h3.1884c.305 1.6311 1.2892 3.0372 2.6478 3.923.9426.6046 2.0794.9702 3.2854.9702v4.3026c-2.2457 0-4.3251-.7171-6.0302-1.9264v8.7318c0 4.3588-3.5766 7.9162-7.9849 7.9162-1.7051 0-3.2716-.5343-4.5747-1.4342C12.3585 31.1457 11 28.7835 11 26.0979c0-4.3589 3.5766-7.9162 7.9849-7.9162.3604 0 .7208.0281 1.0813.0703v1.0123c-4.0202.0985-7.3056 3.1356-7.7492 7.0304.4436-3.8808 3.729-6.9319 7.7492-7.0304v3.3746c-.3466-.1125-.707-.1687-1.0813-.1687-2.0101 0-3.6459 1.617-3.6459 3.6136 0 1.392.7902 2.5872 1.9546 3.1918a3.5937 3.5937 0 0 0 1.6913.4218c1.9685 0 3.5627-1.5467 3.632-3.473V9h4.339c0 .3656.0416.7312.097 1.0967h-3.1745v17.2244Z"
      clipRule="evenodd"
    />
  </svg>
);

export const Telegram = ({ width, height, fill = "black" }: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 43 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="21.5" cy="21.5" r="21.5" fill={fill} />
    <path
      d="M32.06 14.7296L28.5312 31.3581C28.2704 32.5371 27.5685 32.8229 26.5893 32.268L21.2143 28.3065L18.6218 30.8033C18.336 31.089 18.0933 31.3317 17.5385 31.3317L17.9199 25.861L27.8806 16.8615C28.3148 16.4801 27.7849 16.2637 27.2121 16.6452L14.9016 24.3949L9.59594 22.7387C8.44326 22.3753 8.4169 21.586 9.83868 21.0312L30.5675 13.0373C31.5301 12.6905 32.3707 13.2717 32.0586 14.7282L32.06 14.7296Z"
      fill="white"
    />
  </svg>
);

export const Youtube = ({ width, height, fill = "black" }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 46 31"
    fill="none"
  >
    <g clipPath="url(#clip0_1445_2329)">
      <path
        d="M44.0919 26.0607C43.5764 27.9375 42.0529 29.4153 40.1211 29.9178C36.6199 30.8291 22.5741 30.8291 22.5741 30.8291C22.5741 30.8291 8.52832 30.8291 5.02708 29.9178C3.09528 29.4153 1.57178 27.9375 1.05629 26.0607C0.117188 22.6568 0.117188 15.5584 0.117188 15.5584C0.117188 15.5584 0.117188 8.46 1.05629 5.05612C1.57178 3.1793 3.09528 1.70149 5.02708 1.19904C8.53087 0.287722 22.5741 0.287724 22.5741 0.287724C22.5741 0.287724 36.6199 0.287722 40.1211 1.19904C42.0529 1.70149 43.5764 3.1793 44.0919 5.05612C45.031 8.45754 45.031 15.5584 45.031 15.5584C45.031 15.5584 45.031 22.6568 44.0919 26.0607ZM17.9806 9.1127V22.0041L29.7195 15.5584L17.9806 9.1127Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_1445_2329">
        <rect
          width="44.9138"
          height="30.5414"
          fill="white"
          transform="matrix(1 0 0 -1 0.117188 30.8291)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const RSS = ({ width, height, fill = "black" }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 44 44"
    fill="none"
  >
    <g clipPath="url(#clip0_1445_2331)">
      <path
        d="M21.5312 0.0585938C9.65812 0.0585938 0.03125 9.68546 0.03125 21.5586C0.03125 33.4317 9.65812 43.0586 21.5312 43.0586C33.4044 43.0586 43.0312 33.4317 43.0312 21.5586C43.0312 9.68546 33.4044 0.0585938 21.5312 0.0585938ZM13.188 33.2713C11.5899 33.2713 10.2999 31.9813 10.2999 30.3832C10.2999 28.7852 11.5899 27.4952 13.188 27.4952C14.786 27.4952 16.076 28.7852 16.076 30.3832C16.076 31.9813 14.786 33.2713 13.188 33.2713ZM21.6917 33.2713C21.6917 27.078 16.6536 22.0399 10.4604 22.0399V18.1892C18.778 18.1892 25.5424 24.9537 25.5424 33.2713H21.6917ZM28.9118 33.2713C28.9118 23.0989 20.6327 14.8198 10.4604 14.8198V10.969C22.7571 10.969 32.7626 20.9746 32.7626 33.2713H28.9118Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_1445_2331">
        <rect
          width="43"
          height="43"
          fill="white"
          transform="translate(0.03125 0.0585938)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const X = ({ width, height, fill = "black" }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={width}
    height={height}
    viewBox="0 0 44 44"
  >
    <path
      fill={fill}
      d="M44 22c0 12.1503-9.8497 22-22 22C9.84974 44 0 34.1503 0 22 0 9.84974 9.84974 0 22 0c12.1503 0 22 9.84974 22 22Z"
    />
    <path
      fill="#fff"
      d="M23.7123 20.6217 30.4132 13h-1.5879l-5.8183 6.6179L18.3599 13H13l7.0273 10.0074L13 31h1.588l6.1444-6.9887L25.6401 31H31l-7.2878-10.3783h.0004-.0003Zm-2.175 2.4738-.712-.9965-5.6652-7.9294h2.439l4.572 6.3993.712.9964 5.943 8.318h-2.439l-4.8496-6.7876v-.0004l-.0002.0002Z"
    />
  </svg>
);

export const Instagram = ({ width, height, fill = "black" }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 74.11 74.1"
  >
    <defs>
      <clipPath id="b">
        <rect y="0" width="74.11" height="74.1" fill="none" strokeWidth="0" />
      </clipPath>
    </defs>
    <g clipPath="url(#b)">
      <path
        d="m74.11,37.05C74.11,16.59,57.52,0,37.05,0S0,16.59,0,37.05s16.59,37.05,37.05,37.05,37.05-16.59,37.05-37.05"
        fill={fill}
        strokeWidth="0"
      />
      <rect
        x="18.91"
        y="18.53"
        width="37.05"
        height="37.05"
        rx="9.68"
        ry="9.68"
        fill="none"
        stroke="#fff"
        strokeWidth="3.84"
      />
      <circle
        cx="37.44"
        cy="37.11"
        r="8.6"
        fill="none"
        stroke="#fff"
        strokeWidth="3.84"
      />
      <path
        d="m48.41,28.7c1.4,0,2.54-1.14,2.54-2.54s-1.14-2.54-2.54-2.54-2.54,1.14-2.54,2.54,1.14,2.54,2.54,2.54"
        fill="#fff"
        strokeWidth="0"
      />
    </g>
  </svg>
);

export const Pinterest = ({ width, height, fill = "black" }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 44 44"
    fill="none"
  >
    <circle cx="22" cy="22" r="22" fill={fill} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.5 32C27.7467 32 32 27.7467 32 22.5C32 17.2533 27.7467 13 22.5 13C17.2533 13 13 17.2533 13 22.5C13 26.6921 15.7152 30.25 19.483 31.5109C19.5557 31.5643 19.6389 31.5886 19.7224 31.5875C20.601 31.8557 21.5336 32 22.5 32ZM19.7224 31.5875C19.8818 31.5854 20.0425 31.491 20.1347 31.3303C20.3775 30.9047 20.6702 30.3783 20.8324 30.0097C20.9956 29.65 21.1172 29.3153 21.2043 28.9867C21.2967 28.6401 21.3853 28.2969 21.4737 27.9541C21.5548 27.6399 21.6358 27.3261 21.7196 27.0102C22.1984 27.648 22.9528 27.9655 23.8082 27.9493C24.8954 27.9562 25.9093 27.5649 26.7052 26.8208C27.2804 26.2884 27.7694 25.5875 28.0731 24.8379C28.4722 23.852 28.6602 22.666 28.5487 21.6035C28.3745 19.7143 27.1412 18.1036 25.436 17.334C23.729 16.5606 21.52 16.647 19.8254 17.4644C19.03 17.8562 18.3423 18.4178 17.8294 19.1396C16.5053 20.9754 16.3878 23.7048 17.8953 25.4385C18.105 25.6803 18.3502 25.8762 18.6239 26.0206C18.7203 26.0712 18.794 26.0949 18.8558 26.0949C19.0148 26.0949 19.0737 25.9421 19.1074 25.8094C19.1472 25.6511 19.1845 25.4945 19.2217 25.3378C19.2589 25.1811 19.2961 25.0245 19.336 24.8662C19.3678 24.7395 19.3443 24.623 19.2636 24.5106C18.729 23.7642 18.5189 22.919 18.6396 21.999C18.8553 19.9631 20.5771 18.5301 22.6063 18.5455C24.2783 18.5069 25.8296 19.4854 26.2536 21.1504C26.7504 23.0178 25.9333 26.2949 23.617 26.3585C22.7275 26.3594 22.056 25.5908 22.3293 24.7042C22.4083 24.4233 22.4913 24.1384 22.572 23.8614L22.6075 23.7395C22.7024 23.414 22.8001 23.079 22.892 22.7481C23.0529 22.205 23.1782 21.512 22.9109 20.9736C22.721 20.5688 22.3095 20.3326 21.8689 20.3381C21.0647 20.3576 20.5043 20.9309 20.2614 21.7385C20.0425 22.4613 20.0932 23.1886 20.3573 23.91C20.4005 24.028 20.3731 24.1327 20.3441 24.2433C20.2565 24.6161 20.1703 24.9901 20.0843 25.3634C19.8826 26.2386 19.6806 27.1152 19.4558 27.9933C19.2106 28.9584 19.165 29.9369 19.277 30.9502C19.2811 30.9892 19.2807 31.0295 19.2793 31.0825C19.2765 31.1855 19.3042 31.2853 19.3586 31.3712C19.394 31.4304 19.4363 31.4767 19.483 31.5109C19.5623 31.5375 19.6421 31.563 19.7224 31.5875Z"
      fill="white"
    />
  </svg>
);

export const LinkedIn = ({ width, height, fill = "black" }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 44 44"
    fill="none"
  >
    <circle cx="22" cy="22" r="22" fill={fill} />
    <path
      d="M16.7222 32H12.373V18.6476H16.7222V32ZM14.5442 16.8254C13.1456 16.8317 12 15.7587 12 14.4254C12 13.0921 13.1189 12 14.5176 12C15.9163 12 17.0552 13.0667 17.0618 14.4C17.0618 15.7333 15.9363 16.8127 14.5442 16.8254ZM33 32H28.6575V25.4984C28.6575 23.9492 28.6242 21.9619 26.393 21.9619C24.1618 21.9619 23.7821 23.6444 23.7821 25.3841V31.9937H19.4396V18.6476H23.6089V20.4698H23.6689C24.5214 19.0794 26.0999 18.254 27.785 18.3111C32.1874 18.3111 32.9933 21.073 32.9933 24.6603V32H32.9867H33Z"
      fill="white"
    />
  </svg>
);

export const Email = ({ width, height, fill = "black" }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 44 44"
    fill="none"
  >
    <circle cx="22" cy="22" r="22" fill={fill} />
    <path
      d="M31.0615 15H14.1C12.0104 15 12.0106 15.6595 12.0105 16.8136L12 27.6955C12 29.3442 12.3231 29.5091 14.1 29.5091H31.0615C32.6769 29.5091 33 29.5091 33 27.6955V16.9785C33 15.3298 33 15 31.0615 15ZM32.9975 18.2975L22.5 25.5521L12.0105 18.6273V16.8136L22.5 23.7384L32.9975 16.4839V18.2975Z"
      fill="white"
    />
  </svg>
);
